import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const NoteFlagIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 16 16"
        fill="none"
        {...props}
      >
        <path
          d="M3.33333 9.33325H12.6667L9.66667 6.33325L12.6667 3.33325H3.33333V13.9999"
          stroke="#5D708C"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
